import React from 'react';
import { ArrowRightIcon, CheckCircle2Icon, RefreshCcwIcon, ShieldCheckIcon } from 'lucide-react';
const programSteps = ['Dr. Ali or Brenden reviews your biological history, current situation, goals, labs, and previous interventions.', 'You complete a 2 to 3 hour deep-dive designed to uncover what is actually happening and what others may have missed.', 'Your specialist builds a complete, personalized Precision Cell™ transformation program with the exact roadmap to follow.', 'You receive one month of implementation support while you put the program into action and begin making progress.'];
export function WhatYouGetSection() {
  return <section className="grain-section w-full bg-white px-6 py-20 md:py-28" data-id="element-526" data-mp="2xqj9id0swkda">
      <div className="mx-auto max-w-6xl" data-id="element-527" data-mp="2sp3qsrm3ipy2">
        <div className="flex flex-col gap-8 md:flex-row md:items-center" data-id="element-528" data-mp="2sshrzwj0wt3x">
          <div className="font-sans text-8xl font-black tracking-tighter text-teal-50 md:text-9xl" data-id="element-529" data-mp="cxfvf0mqd5hd">
            04
          </div>
          <div className="hidden h-px w-24 bg-teal-100 md:block" data-id="element-530" data-mp="1r3dkmpq9sfvo" />
          <div data-id="element-531" data-mp="1r2vijcgxf7fu">
            <p className="mb-3 text-xs font-bold uppercase tracking-widest text-teal-600" data-id="element-532" data-mp="1r5hleysvgyrq">
              Chapter Four
            </p>
            <h2 className="font-display text-4xl font-black tracking-tight text-ink md:text-6xl" data-id="element-533" data-mp="2111gjizm3tff">
              Why This Offer Exists
              <span className="mt-2 block text-teal-600" data-id="element-534" data-mp="251v6sj0j1kbh">
                (And Why It Won't Last)
              </span>
            </h2>
          </div>
        </div>

        <div className="mt-16 overflow-hidden rounded-[2.5rem] border border-teal-200 bg-teal-50 shadow-[0_20px_55px_rgba(2,132,199,0.1)]" data-id="element-535" data-mp="1dbgv8tfzkk2z">
          <div className="px-7 py-10 text-center md:px-12 md:py-14" data-id="element-536" data-mp="1hc0ty1g7jvr8">
            <p className="text-xs font-black uppercase tracking-[0.2em] text-teal-700" data-id="element-537" data-mp="1m4k4epjlmart">
              Meeting With the Master: Advanced
            </p>
            <h3 className="mx-auto mt-5 max-w-4xl font-display text-3xl font-black leading-tight tracking-tight text-ink md:text-5xl" data-id="element-538" data-mp="pkbdu9uedjqk">
              A One-Month "Lite" Precision Cell™ Transformation Program
            </h3>
            <p className="mx-auto mt-6 max-w-3xl text-lg leading-relaxed text-ink-light md:text-xl" data-id="element-539" data-mp="1s03lj5x132ak">
              We created a way for a limited number of people to access the most
              important transformation work without committing to the longer,
              continually managed program upfront.
            </p>
          </div>
        </div>

        <div className="mt-12 grid gap-6 md:grid-cols-2" data-id="element-540" data-mp="1e0azvp0czc9g">
          <article className="rounded-[2rem] border border-black/[0.07] bg-page-bg p-7 md:p-9" data-id="element-541" data-mp="191rcdk649sez">
            <p className="text-xs font-black uppercase tracking-[0.18em] text-ink/45" data-id="element-542" data-mp="1n18wvncdqjij">
              Full Transformation Program
            </p>
            <p className="mt-4 font-display text-4xl font-black tracking-tight text-ink md:text-5xl" data-id="element-543" data-mp="1ixueiq0yxr1x">
              $15,000 to $45,000+
            </p>
            <p className="mt-5 text-lg leading-relaxed text-ink-light" data-id="element-544" data-mp="2ueu4vg3r9vtb">
              Built for clients who need continual updates, ongoing monitoring,
              and a longer period of hands-on program management.
            </p>
          </article>

          <article className="rounded-[2rem] border-2 border-teal-300 bg-white p-7 shadow-[0_18px_45px_rgba(2,132,199,0.1)] md:p-9" data-id="element-545" data-mp="36utrlowomc03">
            <p className="text-xs font-black uppercase tracking-[0.18em] text-teal-700" data-id="element-546" data-mp="2wygyas51u05v">
              Advanced Lite Program
            </p>
            <p className="mt-4 font-display text-3xl font-black tracking-tight text-teal-700 md:text-4xl" data-id="element-547" data-mp="3kpmi1ie41clg">
              A More Accessible One-Time Investment
            </p>
            <p className="mt-5 text-lg font-semibold leading-relaxed text-ink" data-id="element-548" data-mp="3az9vjkmqj9co">
              Designed to deliver the complete personalized program and initial
              implementation support without months of continual monitoring and
              repeated program updates.
            </p>
          </article>
        </div>

        <div className="mt-20" data-id="element-549" data-mp="ca2o0h5m7q5c">
          <div className="text-center" data-id="element-550" data-mp="caces6yhi1c3">
            <p className="text-xs font-black uppercase tracking-[0.2em] text-teal-700" data-id="element-551" data-mp="2kqlwq24mdq5e">
              What You Actually Receive
            </p>
            <h3 className="mx-auto mt-4 max-w-4xl font-display text-3xl font-black leading-tight tracking-tight text-ink md:text-5xl" data-id="element-552" data-mp="2fskflmqr80wk">
              The Most Important Parts of a Full Transformation Program
            </h3>
            <p className="mx-auto mt-6 max-w-3xl text-lg leading-relaxed text-ink-light md:text-xl" data-id="element-553" data-mp="33fsk42gcz5xj">
              The deep-dive is where your program begins. It is not the entire
              offer. The result is a complete one-month lite transformation
              program built around your unique biology.
            </p>
          </div>

          <ol className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-554" data-mp="2oqe9ys4ykkh3">
            {programSteps.map((step, index) => <li key={step} className="flex gap-5 rounded-[1.75rem] border border-black/[0.07] bg-white p-6 shadow-[0_12px_35px_rgba(26,26,46,0.06)] md:p-7" data-id="element-555" data-mp="3m7bmc72k6fyi" data-mpi={index}>
                <span className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-full bg-teal-600 font-black text-white" data-id="element-556" data-mp="3poqvtu8p1eog">
                  {index + 1}
                </span>
                <p className="pt-1 text-lg font-semibold leading-relaxed text-ink" data-id="element-557" data-mp="2jrk02inax4s">
                  {step}
                </p>
              </li>)}
          </ol>
        </div>

        <div className="mt-12 rounded-[2.25rem] border border-white/10 bg-[#111827] p-8 text-white shadow-[0_24px_65px_rgba(17,24,39,0.2)] md:p-12" data-id="element-558" data-mp="7growa3rdtub">
          <div className="flex flex-col gap-7 md:flex-row md:items-start" data-id="element-559" data-mp="gir91ba2le1h">
            <span className="flex h-14 w-14 flex-shrink-0 items-center justify-center rounded-2xl bg-teal-500/15" data-id="element-560" data-mp="laj0rp4yppt7">
              <ShieldCheckIcon className="h-7 w-7 text-teal-400" aria-hidden="true" data-id="element-561" data-mp="q9vla38d2ksm" />
            </span>
            <div data-id="element-562" data-mp="v988wq723vw9">
              <p className="text-xs font-black uppercase tracking-[0.2em] text-teal-400" data-id="element-563" data-mp="v9qck7w1tce7">
                What Makes It "Lite"
              </p>
              <h3 className="mt-4 font-display text-2xl font-black leading-tight md:text-4xl" data-id="element-564" data-mp="1055rz49pfgcq">
                Less Ongoing Management. Not a Lesser Program.
              </h3>
              <p className="mt-5 text-lg leading-relaxed text-white/70 md:text-xl" data-id="element-565" data-mp="5m4g4ufaqqg1">
                The lite format can potentially accomplish everything a full
                transformation program can accomplish when you do not require
                continual updates, long-term monitoring, or months of hands-on
                management. You still receive the personalized program and one
                month of implementation support needed to begin executing it.
              </p>
            </div>
          </div>
        </div>

        <div className="mt-12 overflow-hidden rounded-[2.25rem] border-2 border-teal-300 bg-teal-50 shadow-[0_20px_55px_rgba(2,132,199,0.12)]" data-id="element-566" data-mp="y98ggm3g2glh">
          <div className="grid gap-8 p-8 md:grid-cols-[auto_1fr] md:p-12" data-id="element-567" data-mp="34zyeueqsgtt3">
            <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-teal-600 text-white" data-id="element-568" data-mp="3013j6c7q3ark">
              <RefreshCcwIcon className="h-7 w-7" aria-hidden="true" data-id="element-569" data-mp="1fjm2h8e5lo27" />
            </span>
            <div data-id="element-570" data-mp="1kgchdse82dm1">
              <p className="text-xs font-black uppercase tracking-[0.2em] text-teal-700" data-id="element-571" data-mp="1kgumleiv4263">
                Upgrade Without Losing Your Investment
              </p>
              <h3 className="mt-4 font-display text-2xl font-black leading-tight text-ink md:text-4xl" data-id="element-572" data-mp="1ar19ua6zhh09">
                Apply Your Full Investment Toward a Full Transformation Program
              </h3>
              <p className="mt-5 text-lg leading-relaxed text-ink-light md:text-xl" data-id="element-573" data-mp="10twpmfwp7vm3">
                If you decide you need the longer, hands-on experience, you can
                upgrade within 30 days and apply your entire lite-program
                investment to the full program. You do not pay for the same
                transformation work twice, and nothing you invested is lost.
              </p>
            </div>
          </div>
        </div>

        <div className="mx-auto mt-16 max-w-3xl text-center" data-id="element-574" data-mp="2m4n94o6k4yzi">
          <CheckCircle2Icon className="mx-auto h-8 w-8 text-teal-600" aria-hidden="true" data-id="element-575" data-mp="18ytt84yhbfem" />
          <h3 className="mt-5 font-display text-3xl font-black leading-tight text-ink md:text-5xl" data-id="element-576" data-mp="14zck91jug04p">
            Start With the Lite Program. Upgrade Only If You Need More.
          </h3>
          <p className="mt-6 text-lg leading-relaxed text-ink-light md:text-xl" data-id="element-577" data-mp="v8zzb884a4y1">
            Get the diagnosis-level thinking, complete personalized program, and
            implementation support now. If your situation later requires ongoing
            management, your entire investment can move forward with you.
          </p>
          <a href="#advanced-price" className="mt-8 inline-flex w-full items-center justify-center gap-3 rounded-2xl bg-emerald-600 px-9 py-5 text-center text-base font-black text-white shadow-[0_12px_32px_rgba(5,150,105,0.3)] ring-1 ring-emerald-500 transition-all duration-200 hover:-translate-y-1 hover:bg-emerald-700 hover:shadow-[0_18px_42px_rgba(5,150,105,0.35)] focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-emerald-300/50 sm:w-auto sm:text-lg" data-id="element-578" data-mp="h98spsjxjqu2">
            Book Your Meeting With the Master: Advanced
            <ArrowRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-579" data-mp="2j3wgx7jws4k3" />
          </a>
        </div>
      </div>
    </section>;
}